module.exports = __webpack_public_path__ + "04_short_brown.05f31f18.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/04_short_brown.png
// module id = VKwh
// module chunks = 0